<template>
  <b-modal
    v-model="showModal"
    title="BDX Status"
    body-class="py-0 px-4"
    footer-class="p-4"
    size="lg"
    hide-footer
  >
    <BDXStatusModalFilters v-model="filters" />
    <BDXStatusModalForm @saved="() => $emit('input', false)" />
  </b-modal>
</template>

<script>
import { defineComponent, computed, provide, ref } from '@vue/composition-api'

import BDXStatusModalForm from './BDXStatusModalForm.vue'
import BDXStatusModalFilters from './BDXStatusModalFilters.vue'

export default defineComponent({
  name: 'BDXStatusModal',
  components: {
    BDXStatusModalForm,
    BDXStatusModalFilters
  },
  emits: ['input'],
  props: {
    value: Boolean
  },
  setup(props, { emit }) {
    const showModal = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    const filters = ref({
      bdx_status: 'All',
      fcp_status: 'All',
      reserve: 'All',
      claim_status: 'All'
    })

    const pagination = ref({
      page: 1,
      page_size: 100
    })
    const setPagination = (newPagination) => (pagination.value = newPagination)

    provide('global-umr-modal', {
      filters,

      pagination,
      setPagination
    })

    return {
      showModal,

      filters
    }
  }
})
</script>
